class CollectionProductContainer extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.isConnected && !this.initialized) {
        this.initialized = true;
        this.waitForStylesheetAndLoad();
      }
      this.addEventListener('refresh-swiper', this.refreshSwiper);
    }

    waitForStylesheetAndLoad() {
      if (document.readyState === 'complete' && typeof Swiper !== 'undefined') {
        this.initSwiper();
      } else {
        window.addEventListener('load', () => {
          setTimeout(() => this.initSwiper(), 100);
        });
      }
    }

    initSwiper() {
      this.swiper = new Swiper(this.querySelector('.collection-slider-container'), {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        centeredSlides: true,
        pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'bullets'
        },
        navigation: {
          nextEl: this.querySelector('.ExpertsSliderNav__Next'),
          prevEl: this.querySelector('.ExpertsSliderNav__Prev'),
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled'
        },
        on: {
          reachBeginning: function() {
            const prevButton = this.navigation.prevEl;
            if (prevButton) prevButton.style.display = 'none';
          },
          reachEnd: function() {
            const nextButton = this.navigation.nextEl;
            if (nextButton) nextButton.style.display = 'none';
          },
          fromEdge: function() {
            const { prevEl, nextEl } = this.navigation;
            if (prevEl) prevEl.style.display = 'flex';
            if (nextEl) nextEl.style.display = 'flex';
          }
        }
      });
    }
}
customElements.define('collection-product-container', CollectionProductContainer);

document.addEventListener("DOMContentLoaded", function() {
    var collectionContainers = document.querySelectorAll('.collection-container');
    collectionContainers.forEach(function(collectionContainer) {
        var swiperSlides = collectionContainer.querySelectorAll('.swiper-slide');
        if (swiperSlides.length > 1) {
            collectionContainer.classList.add('multiple-slides');
        }
    });
});

  
